/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type MonitorQualifyDto = {
    comment?: string | null;
    userAnomalyStatus: MonitorQualifyDto.userAnomalyStatus;
    userEvaluationStatus: MonitorQualifyDto.userEvaluationStatus;
};

export namespace MonitorQualifyDto {

    export enum userAnomalyStatus {
        ANOMALY = 'ANOMALY',
        NOT_ANOMALY = 'NOT_ANOMALY',
    }

    export enum userEvaluationStatus {
        PENDING = 'PENDING',
        REVIEWED = 'REVIEWED',
    }


}
